module.exports = __webpack_public_path__ + "static/media/foto.3bc33369.jpg";